import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DateTime } from 'luxon';
import { MatDivider, MatNavList, MatListSubheaderCssMatStyler, MatListItem, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { MatRipple } from '@angular/material/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
	selector: 'vex-quickpanel',
	templateUrl: './quickpanel.component.html',
	styleUrls: ['./quickpanel.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDivider, MatNavList, MatListSubheaderCssMatStyler, MatListItem, RouterLink, MatListItemTitle, MatListItemLine, MatRipple, MatProgressBar],
})
export class QuickpanelComponent {
	date = DateTime.local().toFormat('DD');
	dayName = DateTime.local().toFormat('EEEE');
}
